module.exports = __webpack_public_path__ + "img/2025-ford-escape.655ea0a8.png";